<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline :title="roleId ? 'Edit Role' : 'Create Role'">
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'SystemRoles' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>Back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form @submit.prevent="save">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">Name <span class="error--text">*</span></label>
                <v-text-field placeholder="Role Name" class="my-1 py-0" v-model.trim="role.role" :counter="50" required name="name"> </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">Description <span class="error--text">*</span></label>
                <v-text-field class="my-1 py-0" placeholder="Description for Role" name="description" :counter="50" required v-model.trim="role.description"> </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">Scope Level <span class="error--text">*</span></label>
                <v-text-field class="my-1 py-0" placeholder="Scope Level for Role" name="scopeLevel" v-model.trim="role.scopeLevel" :counter="50" required> </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">Roles</label>
                <v-select class="my-1 py-0" placeholder="--SELECT--" v-model.trim="role.selectedroleID" :items="roles" light multiple item-text="role" item-value="id">
                  <template v-slot:selection="{ item }">
                    <v-chip small dark class="font-weight-medium" color="darkblue lighten-1">
                      <span>{{ item.role }}</span>
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right elevation="1" :class="{ 'is-loading': lock }" :disabled="lock" color="primary" type="submit">
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
    </v-container>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import _sortBy from 'lodash/sortBy'
import MaterialCard from '@/components/template/MaterialCard'

// import Multiselect from 'vue-multiselect'
const _ = require('lodash')

export default {
  name: 'SaveRole',
  components: { MaterialCard },
  props: ['roleId'],
  data: function () {
    return {
      role: {
        role: '',
        description: '',
        scopeLevel: '',
        roleID: ''
      },
      selectedroleID: [],
      roles: [],
      lock: false,
      allSystemEndPoints: [],
      tags: {
        GET: 'has-text-primary',
        PUT: 'has-text-link',
        POST: 'has-text-success',
        DELETE: 'has-text-danger'
      },
      manageAccess: false,
      loadingComponent: null
    }
  },
  async created () {
    this.isLoading = true
    await this.getRoleList()
    http
      .get(`${CONSTANTS.API_URL}/api/systemendpoints`)
      .then(async endPoints => {
        this.allSystemEndPoints = endPoints.data
        this.isLoading = false
        if (this.roleId) {
          await this.getRole()
        }
      })
      .catch(httpException => {
        console.log('Error While Saving Admin Role', httpException)
        this.lock = false
        this.isLoading = false

        return this.$dialog.error({
          title: 'Error',
          text: 'Error while Saving Role'
        })
      })
  },
  methods: {
    getRole: async function () {
      if (!this.roleId) return
      this.isLoading = true
      let role = await http.get(`${CONSTANTS.API_URL}/api/role/${this.roleId}`)
      try {
        this.role = role.data
        let roleData = _.map(this.role.rolesChildMaps, 'childRoleID')
        this.selectedroleID = roleData
        this.role.selectedroleID = roleData
        let roleAccesses = this.role.systemEndPoints

        for (let i = 0; i < roleAccesses.length; i++) {
          for (var j = 0; j < this.allSystemEndPoints.length; j++) {
            if (this.allSystemEndPoints[j].id === roleAccesses[i].id && roleAccesses[i].roleEndPointMap.isActive) {
              this.allSystemEndPoints[j].isAssigned = true
              this.allSystemEndPoints[j].roleEndPointMap = roleAccesses[i].roleEndPointMap
            }
          }
        }
        this.allSystemEndPoints = _sortBy(this.allSystemEndPoints, ['module'])
        this.manageAccess = true
        this.isLoading = false
      } catch (httpException) {
        console.log('Error While Saving Admin Role', httpException)
        this.lock = false
        this.isLoading = false

        return this.$dialog.error({
          title: 'Error',
          text: 'Error while Saving Role'
        })
      }
    },
    getRoleList: async function () {
      try {
        // this.isLoading = true
        const { data } = await http.get(`${CONSTANTS.API_URL}/api/roles`)
        this.roles = data
        this.isLoading = false

        return this.roles
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching role', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    save: function () {
      if (this.lock) {
        return
      }
      this.isLoading = true
      let roleId = _.map(this.selectedroleID, 'id')
      this.selectedroleID = roleId
      this.role.roleID = this.role.selectedroleID
      this.lock = true
      let transaction
      if (this.roleId) {
        transaction = http.put(`${CONSTANTS.API_URL}/api/role/${this.roleId}`, this.role)
      } else {
        transaction = http.post(`${CONSTANTS.API_URL}/api/role`, this.role)
      }
      transaction
        .then(data => {
          let role = data.data
          this.isLoading = false

          if (role && role.id) {
            this.manageAccess = true
            this.lock = false
            this.$router.push({
              name: 'SystemSaveRoles',
              params: { roleId: role.id }
            })
            this.getRole()
          } else {
            this.$router.push({
              name: 'SystemRoles'
            })
          }

          return this.$dialog.info({
            title: 'Success',
            text: 'Role Details Saved successfully!'
          })
        })
        .catch(httpException => {
          console.log('Error While Saving Admin Role', httpException)
          this.lock = false
          this.isLoading = false

          return this.$dialog.error({
            title: 'Error',
            text: 'Error while Saving Role'
          })
        })
    },

    allowAccess: function (endPoint) {
      if (this.lock) return
      this.isLoading = true

      this.lock = true
      let endpoint = {}
      endpoint.roleId = this.roleId
      endpoint.endPointId = endPoint.id
      http
        .post(`${CONSTANTS.API_URL}/api/role/allowaccess`, endpoint)
        .then(() => {
          this.lock = false
          this.isLoading = false
          this.getRole()

          return this.$dialog.info({
            title: 'Success',
            text: 'Access Granted!',
            timeout: 2000
          })
        })
        .catch(err => {
          console.log('Error while granting Access!', JSON.stringify(err))
          this.lock = false
          this.isLoading = false

          return this.$dialog.error({
            title: 'Error',
            text: 'Error while granting Access!',
            timeout: 2000
          })
        })
    },
    removeAccess: function (endPoint) {
      if (this.lock || endPoint.isAssigned === undefined) {
        return
      }
      this.isLoading = true

      this.lock = true
      let obj = {}
      obj.mappingId = endPoint.roleEndPointMap.id
      obj.roleId = this.roleId
      obj.endPointId = endPoint.id
      http
        .put(`${CONSTANTS.API_URL}/api/role/removeaccess`, obj)
        .then(() => {
          this.lock = false
          this.isLoading = false
          this.getRole()

          return this.$dialog.info({
            title: 'Success',
            text: 'Removed Access successfully!',
            timeout: 2000
          })
        })
        .catch(err => {
          console.log('Error while Removing Access!', JSON.stringify(err))
          this.lock = false
          this.isLoading = false
          return this.$dialog.error({
            title: 'Error',
            text: 'Error while Removing Access!',
            timeout: 2000
          })
        })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
